module.exports = "<!-- Navigation/Header -->\r\n<app-navigation></app-navigation>\r\n<!-- Navigation/Header -->\r\n\r\n<!-- Spinner/Loader -->\r\n<ng4-loading-spinner> </ng4-loading-spinner>\r\n<!-- Spinner/Loader -->\r\n\r\n<!-- Content/Body -->\r\n<router-outlet></router-outlet>\r\n<!-- Content/Body -->\r\n\r\n<!-- Snack Bar -->\r\n<ztsi-snack-bar></ztsi-snack-bar>\r\n<!-- Snack Bar -->\r\n\r\n<app-messages></app-messages>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main